import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const listFieldDetails = (request) => {  // NOT USING NOW - 
    const ENDPOINT = URL_BASE_API+'affiliate/vehicle-field-details_v2/?column=id&page=0';  
    return service.get(ENDPOINT);
}
export const saveFieldDetails = (request) => {  
    const ENDPOINT = URL_BASE_API+'affiliate/vehicle-field-details_v2/';
    return service.post(ENDPOINT,request.data); 
}
export const deleteFieldDetails = (request) => {  
    let id = request.data
    const ENDPOINT = URL_BASE_API+'affiliate/vehicle-field-details_v2/'+id;
    return service.delete(ENDPOINT,request.data); 
}

export const listVehicleInfo = (request) => {  
    //let ENDPOINT = URL_BASE_API+'affiliate/vehicle/?page=0&column=affiliatevehicledetails_set__id';
    let ENDPOINT = URL_BASE_API+'affiliate/vehicle_v2/?page=0&column=affiliatevehicledetails_set__id';
    if(request.data){
        ENDPOINT = URL_BASE_API+'affiliate/vehicle_v2/?page=0&column=affiliatevehicledetails_set__id&crew_id='+request.data;
    }
    
    return service.get(ENDPOINT); 
}

export const saveVehicleInfo = (request) => {  
    let crew_id = '';
    let data = request.data.vehicle_details;
    let is_approved = request.data.is_approved?request.data.is_approved:false;
    let ENDPOINT = URL_BASE_API+'affiliate/vehicle_v2/?is_approved='+is_approved;
    
    if(request.data.crewId){
        crew_id = request.data.crewId
        ENDPOINT = URL_BASE_API+'affiliate/vehicle_v2/?crew_id='+crew_id+"&is_approved="+is_approved;
    }

    return service.post(ENDPOINT,data); 
}
export const updateVehicleInfo = (request) => {  
	let id = request.data.id
	let vehicle_details = request.data.vehicle_details
    let is_approved = request.data.is_approved?request.data.is_approved:false;
    const ENDPOINT = URL_BASE_API+'affiliate/vehicle_v2/'+id+"?is_approved="+is_approved;
    return service.put(ENDPOINT,vehicle_details); 
}
export const deleteVehicleInfo = (request) => {  
	let id = request.data
    const ENDPOINT = URL_BASE_API+'affiliate/vehicle_v2/'+id;
    return service.delete(ENDPOINT); 
}
export const getVehicleInfo = (request) => {  
	let id = request.data
    const ENDPOINT = URL_BASE_API+'affiliate/vehicle_v2/'+id;
    return service.get(ENDPOINT); 
}